var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail-wrap"},_vm._l((_vm.selected),function(obj,i){return _c('div',{key:i,staticClass:"selected",style:(_vm.getStyle(obj.coords))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }